var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuerybuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.593,
    height: 26,
    viewBox: "0 0 17.593 20.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.022 -387.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3166.029 1242.58)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.797,
    cy: 2.07,
    rx: 8.797,
    ry: 2.07,
    transform: "translate(3185.052 -855.579)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2624.337-883v4.114s3.031,1.515,8.985,1.515,8.607-1.515,8.607-1.515V-883a21.676,21.676,0,0,1-8.607,1.313A30.589,30.589,0,0,1,2624.337-883Z",
    transform: "translate(560.715 31.269)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2624.337-883v4.114s3.031,1.515,8.985,1.515,8.607-1.515,8.607-1.515V-883a21.676,21.676,0,0,1-8.607,1.313A30.589,30.589,0,0,1,2624.337-883Z",
    transform: "translate(560.715 36.669)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2624.337-883v4.114s3.031,1.515,8.985,1.515,8.607-1.515,8.607-1.515V-883a21.676,21.676,0,0,1-8.607,1.313A30.589,30.589,0,0,1,2624.337-883Z",
    transform: "translate(560.715 41.89)",
    fill: "#fafafa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuerybuilder);
export default __webpack_public_path__ + "static/media/querybuilder.7a90e70314e47f453e3eae43970148a0.svg";
export { ForwardRef as ReactComponent };